import type { ClientGPSLocation } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQuery } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useSharedAppApi } from '@/features/api/hooks/shared-app/useSharedAppApi';

export const useGetNearestGeoArea = (position?: ClientGPSLocation) => {
  const api = useSharedAppApi();
  return useQuery({
    queryKey: [API_CACHE_KEYS.NEAREST_GEO_AREA, { position }],
    enabled: Boolean(position),
    queryFn: () =>
      api.getNearestGeoAreaForAppVariant({
        latitude: position?.latitude ?? 0,
        longitude: position?.longitude ?? 0
      })
  });
};
